import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DamageEventDetailByIdService } from './damage-event-detail-by-id/damage-event-detail-by-id.service';

@NgModule({
  imports: [CommonModule],
  providers: [DamageEventDetailByIdService],
})
export class DamageEventsModule {}
